export const HTML_CONSTRUCTOR_BLOCK_TOOLBAR_POSITION_TOP = "top";
export const HTML_CONSTRUCTOR_BLOCK_TOOLBAR_POSITION_BOTTOM = "bottom";

export type HtmlConstructorBlockToolbarPosition = "top" | "bottom";